import { useStorage } from '@vueuse/core'
import { cloneDeep, isNull } from 'lodash'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

import { ROUTE_NAMES } from '@/routes/route-helpers'
import { isLocalStorageAvailable } from '@/utils/persist'
import { isTimestampExpired } from '@web-app/utils/stores-timestamp'

const DEFAULT_REFERER_ROUTE_STATE = {
  refererRoute: null,
  expiry: null
}

export const useLoginAppRoutes = () => {
  const router = useRouter()

  const gatewayPath = computed(() => {
    return router.resolve({ name: ROUTE_NAMES.WEB_APP_AFTER_LOGIN_GATEWAY })?.path || '/'
  })

  return {
    gatewayPath
  }
}

export const useRefererRoute = () => {
  const refererRouteState = isLocalStorageAvailable()
    ? useStorage('referer-store', cloneDeep(DEFAULT_REFERER_ROUTE_STATE))
    : ref(cloneDeep(DEFAULT_REFERER_ROUTE_STATE))

  const setState = (newState = DEFAULT_REFERER_ROUTE_STATE) => {
    refererRouteState.value = cloneDeep(newState)
  }

  const refererRoute = ref('')

  const resolveRefererRoute = () => {
    const isRefererRouteExist = !isNull(refererRouteState.value.refererRoute)

    const isRefererRouteValid =
      isRefererRouteExist && !isTimestampExpired(refererRouteState.value.expiry)

    if (isRefererRouteValid) {
      refererRoute.value = refererRouteState.value.refererRoute
    }

    refererRouteState.value = cloneDeep(DEFAULT_REFERER_ROUTE_STATE)
  }

  return {
    refererRoute,
    refererRouteState,
    resolveRefererRoute,
    setState
  }
}
